import { match } from 'ts-pattern';

export const SexEnum = ['ALL', 'F', 'M'] as const;

export type SexEnumType = (typeof SexEnum)[number];

export function toIsMaleFilter(sex: SexEnumType) {
  return match(sex)
    .with('F', () => false)
    .with('M', () => true)
    .otherwise(() => undefined);
}
